import React, { useEffect, useState } from "react";

import apiClient from "../../services/apiClient";
import "./AdminCafeEventPage.css";

// 관리자 > 카페 이벤트(2026-10-08). 지인에듀 cafe_leveltest 를 옮겨 온 화면(api/echo/cafe_event.py)의 신청을
// 승인하고, 수학 변형문제 파일 주소를 넣고, 200P 를 지인에듀에서 넣은 뒤 '지급함' 을 누른다.
// 승인은 텔레그램(@ginecho_bot 대표님 방) 버튼으로도 된다.

const ENDPOINT = "/api/v1/echo/admin/cafe-event";
const STATUS_LABEL = { pending: "승인 대기", approved: "승인", rejected: "거절" };

const formatTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return `${date.getMonth() + 1}/${date.getDate()} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
};

const AdminCafeEventPage = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [urlByKind, setUrlByKind] = useState({});
  const [filter, setFilter] = useState("pending");

  const apply = (result) => {
    setData(result);
    setUrlByKind(Object.fromEntries((result.material_list || []).map((item) => [item.kind, item.file_url])));
  };

  useEffect(() => {
    apiClient
      .get(ENDPOINT, { withAuth: true })
      .then((response) => apply(response.data))
      .catch((requestError) => setError(requestError?.response?.data?.error || "불러오지 못했어요."));
  }, []);

  const act = (entryId, action) =>
    apiClient
      .post(ENDPOINT, { entry_id: entryId, action }, { withAuth: true })
      .then((response) => apply(response.data))
      .catch((requestError) => alert(requestError?.response?.data?.error || "처리하지 못했어요."));

  const saveMaterials = () =>
    apiClient
      .post(ENDPOINT, { materials: Object.entries(urlByKind).map(([kind, file_url]) => ({ kind, file_url })) }, { withAuth: true })
      .then((response) => {
        apply(response.data);
        alert("저장했어요.");
      })
      .catch(() => alert("저장하지 못했어요."));

  if (error) return <p className="cafe-admin__error">{error}</p>;
  if (!data) return <p className="cafe-admin__sub">불러오는 중…</p>;

  const entryList = data.entry_list.filter((row) =>
    filter === "all" ? true : filter === "point" ? row.point_requested_at && !row.point_granted_at : row.status === filter
  );
  const count = (predicate) => data.entry_list.filter(predicate).length;

  return (
    <div className="cafe-admin">
      <div className="cafe-admin__head">
        <h2>카페 이벤트</h2>
        <a href={data.page_url} target="_blank" rel="noopener noreferrer">{data.page_url}</a>
      </div>
      {!data.has_gift_link && (
        <p className="cafe-admin__error">
          레벨테스트 이용권 링크가 아직 없어요. 승인돼도 이용권 버튼이 열리지 않아요(운영 명령 leveltest_gift_link --create --cafe).
        </p>
      )}

      <div className="cafe-admin__filters">
        {[
          ["pending", `승인 대기 ${count((row) => row.status === "pending")}`],
          ["approved", `승인 ${count((row) => row.status === "approved")}`],
          ["point", `200P 지급 필요 ${count((row) => row.point_requested_at && !row.point_granted_at)}`],
          ["rejected", `거절 ${count((row) => row.status === "rejected")}`],
          ["all", `전체 ${data.entry_list.length}`],
        ].map(([key, label]) => (
          <button key={key} type="button" className={filter === key ? "on" : ""} onClick={() => setFilter(key)}>
            {label}
          </button>
        ))}
      </div>

      <div className="cafe-admin__table-wrap">
        <table className="cafe-admin__table">
          <thead>
            <tr>
              <th>카페 닉네임</th>
              <th>신청</th>
              <th>상태</th>
              <th>이용권 받은 아이디</th>
              <th>자료</th>
              <th>200P</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {entryList.map((row) => (
              <tr key={row.id}>
                <td className="cafe-admin__strong">{row.nickname}</td>
                <td>{formatTime(row.created_at)}<div className="cafe-admin__sub">{row.ip}</div></td>
                <td>{STATUS_LABEL[row.status]}</td>
                <td>{row.gift_nickname}</td>
                <td>{row.download_count || ""}</td>
                <td>
                  {row.point_login_id && (
                    <>
                      <span className="cafe-admin__strong">{row.point_login_id}</span>
                      {row.point_place_url && (
                        <div><a href={row.point_place_url} target="_blank" rel="noopener noreferrer">지도</a></div>
                      )}
                      {row.point_granted_at ? (
                        <div className="cafe-admin__sub">지급함 {formatTime(row.point_granted_at)}</div>
                      ) : (
                        <button type="button" onClick={() => act(row.id, "point_granted")}>지급함</button>
                      )}
                    </>
                  )}
                </td>
                <td className="cafe-admin__actions">
                  {row.status !== "approved" && <button type="button" className="ok" onClick={() => act(row.id, "approve")}>승인</button>}
                  {row.status !== "rejected" && <button type="button" onClick={() => act(row.id, "reject")}>거절</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h3>수학 변형문제 파일 주소</h3>
      <div className="cafe-admin__materials">
        {data.material_list.map((item) => (
          <label key={item.kind}>
            <span>{item.label}</span>
            <input
              type="url"
              value={urlByKind[item.kind] || ""}
              placeholder="https:// (비어 있으면 화면에 '올리는 중' 으로 떠요)"
              onChange={(event) => setUrlByKind((previous) => ({ ...previous, [item.kind]: event.target.value }))}
            />
          </label>
        ))}
        <button type="button" className="ok" onClick={saveMaterials}>저장</button>
      </div>
    </div>
  );
};

export default AdminCafeEventPage;
